import { makeStyles } from "@mui/styles";
import { green } from "@mui/material/colors";

const useStyles = makeStyles({
	root: {
		color: green[400],
		"&$checked": {
			color: green[600]
		}
	},
	checked: {}
});

export default useStyles;
